import React from 'react';
import { Stack, Text, Divider } from '@moda/om';
import { PaymentSummaryRow } from '../PaymentSummary/PaymentSummaryRow';
import { useOrderDetails } from '../OrderDetails';

export const OrderDetailsRewardsSummary: React.FC = () => {
  const { orderSummary } = useOrderDetails();

  if (!orderSummary) return null;

  const {
    attributes: {
      eligibleForRewards,
      paymentSummary: { payToday, rewardPointsEarned, rewardPointsRedeemed, pendingPoints }
    }
  } = orderSummary;

  if (!eligibleForRewards) return null;

  return (
    <Stack className="OrderRewardsSummary" space={4}>
      <Text treatment="h6">
        <h2>M'O Rewards Summary</h2>
      </Text>

      <Divider />

      <PaymentSummaryRow label="Points Redeemed" value={rewardPointsRedeemed} />

      <PaymentSummaryRow label="Points Earned" value={rewardPointsEarned} />

      {Number(payToday.price) > 0 && (
        <PaymentSummaryRow label="Pending Points" value={pendingPoints} />
      )}
    </Stack>
  );
};
